<app-spinner-overlay></app-spinner-overlay>

<div>
  <header>
    <img [src]="logoPath" alt="Sostenibile" class="logo-path" />
  </header>
</div>
<div class="contenitore" *ngIf="!messaggioErrore && !completato && compilazione">
  <ng-scrollbar>
    <div>
      <div class="landing-page" *ngIf="landingPage" [innerHtml]="landingPage"></div>
      <div
        style="
          align-items: center;
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 50px;
        "
      >
        <div>
          <div style="font-size: 32px; color: var(--mat-color-accent); font-family: Abel">
            {{ compilazione.titolo }} {{ esercizio }}
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #707070;
            flex: 1;
            margin-right: 20px;
            margin-left: 20px;
          "
        ></div>
      </div>
      @if (!messaggioErrore && compilazione && esercizio && idAutovalutazioneCompilata) {
        <app-compila-assessment
          #compila
          style="margin-right: 25px"
          [idModulo]="idAutovalutazioneCompilata"
          [temporaryToken]="temporaryToken"
          [compilazione]="compilazione"
          [salva]="salva"
          (completato)="compilazioneCompletata($event)"
        >
        </app-compila-assessment>
      }
    </div>
  </ng-scrollbar>
</div>

<div class="messaggio" *ngIf="messaggioErrore" [innerHtml]="messaggioErrore"></div>

<div class="messaggio" *ngIf="!messaggioErrore && completato">
  Le tue risposte sono state salvate. Grazie.
</div>
